import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../shared/global';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';
@Injectable()
export class CustomerEnrollService {
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest = GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private customer_enroll_url = this.baseApiUrl+'api/rest/v1/auth/register/';
  // private customer_enroll_url = this.baseApiUrl+'api/rest/v1/auth/new/register/';
  private customer_enroll_url = this.baseApiUrlTest + 'api/enrollment/complete';
  private customer_pre_enroll_url = this.baseApiUrlTest + 'api/enrollment/pre';
  // private customer_sg_enroll_url = this.baseApiUrl+'api/rest/v1/auth/create/';
  // private change_mobile_url = this.baseApiUrlTest+'api/rest/v1/auth/change/mobile/';
  private change_mobile_url = this.baseApiUrlTest + 'api/account/change/mobile';
  // private check_mobile_url = this.baseApiUrl+'api/rest/v1/auth/mobile/';
  private check_mobile_url = this.baseApiUrlTest + 'api/auth/check/mobile';
  // private check_email_url = this.baseApiUrl+'api/rest/v1/auth/email/';
  private check_email_url = this.baseApiUrlTest + 'api/auth/check/email';
  // private holiday_list = this.baseApiUrl+'api/rest/v1/get/calendar/';
	private customer_enroll_payment_url = this.baseApiUrlTest + 'api/enrollment/complete/payment';
	private holiday_list = this.baseApiUrlTest + 'api/enrollment/get/calendar/';
  private enroll_check_mobile_url = this.baseApiUrlTest + 'api/auth/check/mobile_enroll';
  private enroll_check_email_url = this.baseApiUrlTest + 'api/auth/check/email_enroll';
  private lookup_url = this.baseApiUrlTest + 'api/twilio/lookup';
  private verify_identity_url = this.baseApiUrlTest + 'api/enrollment/verify-identity';
  private cancel_enroll_url = this.baseApiUrlTest + 'api/enrollment/cancel';

  constructor(private http: Http, private localStorageService: LocalStorageService) { }

  //validate mobile no exist or not
  checkMobileNoAlreadyRegister(mobile_phone_number: Object){
    return this.http
      .post(this.enroll_check_mobile_url, mobile_phone_number)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  //validate email no exist or not
  checkEmailAlreadyRegister(email: Object){
    return this.http
      .post(this.enroll_check_email_url, email)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  //Get carrier info for phone number
  lookupPhoneNumber(lookupRequest: Object){
    return this.http
    .post(this.lookup_url, lookupRequest)
    .toPromise()
    .then(res => res.json())
    .catch(this.handleError);
  }
  preEnrollCustomer(cust_enroll_json: Object): Promise<any> {
    cust_enroll_json['ProductID'] = this.localStorageService.get('ProductID');
    cust_enroll_json['zipcode'] = <string>this.localStorageService.get('zipcode_for_enroll');
    cust_enroll_json['address'] = <string>this.localStorageService.get('address_for_enroll');
    return this.http
      .post(this.customer_pre_enroll_url, cust_enroll_json)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  completeEnrollment(enrollment: any): Promise<any> {
    return this.http
      .post(this.customer_enroll_url, enrollment)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  // create cutomer enrollment
  createCustEnroll(cust_enroll_json: Object): Promise<any>{
    cust_enroll_json['ProductID'] = this.localStorageService.get('ProductID');
    cust_enroll_json['zipcode'] = <string>this.localStorageService.get('zipcode_for_enroll');
    cust_enroll_json['address'] = <string>this.localStorageService.get('address_for_enroll');
    return this.http
      .post(this.customer_enroll_url, cust_enroll_json)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
	completeEnrollmentPayment(enrollment: any): Promise<any> {
		return this.http
			.post(this.customer_enroll_payment_url, enrollment)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

  // custSGEnroll(cust_sg_enroll_json: Object): Promise<any>{
  //   return this.http
  //     .post(this.customer_sg_enroll_url, cust_sg_enroll_json)
  //     .toPromise()
  //     .then(res => res.json())
  //     .catch(this.handleError);
  // }

  //chnage phone no
  changeMobileNo(change_mobile: Object): Promise<any>{
      return this.http
      .post(this.change_mobile_url, change_mobile)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  // Identity / trust check performed when leaving Setup Service (step 3). The Amber API
  // resolves the legacy customer id from the token and proxies to the trust service so the
  // x-api-key is never exposed to the browser.
  verifyIdentity(request: Object): Promise<any> {
    return this.http
      .post(this.verify_identity_url, request)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  // STUB: deletes / inactivates the partially-enrolled Amber account when the customer
  // cancels from the "Cash Only" page.
  // TODO: wire up to the real endpoint once the backend is available.
  cancelEnrollment(request: Object): Promise<any> {
    // return this.http
    //   .post(this.cancel_enroll_url, request)
    //   .toPromise()
    //   .then(res => res.json())
    //   .catch(this.handleError);
    return Promise.resolve({ status: 'success' });
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  getHolidayList(tdsp: any){
   return this.http
     .post(this.holiday_list, tdsp)
     .toPromise()
     .then(res => res.json())
     .catch(this.handleError);
   }

}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/customer-enroll.service.ts